import gql from 'graphql-tag'

export default gql`
  query GetUser {
    currentUser {
      firstName
      lastName
      email
      scentregroupId
      onboarding {
        web {
          required
        }
      }
      storedPaymentMethods {
        stripePaymentMethodId
        brand
        expMonth
        expYear
        last4
        defaultAt
        createdAt
        billingAddress {
          id
          firstName
          lastName
          streetAddress
          suburb
          state
          postcode
          country
          createdAt
          defaultAt
        }
      }
      storedAddresses {
        id
        firstName
        lastName
        streetAddress
        suburb
        state
        postcode
        country
        defaultAt
        createdAt
      }
    }
  }
`
